// extracted by css-extract-rspack-plugin
export default {"jumpWiggle":"JumpWiggle-module__jumpWiggle__u9hJG","copilotRun":"JumpWiggle-module__copilotRun__lgr6O"};